var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"zg-lookup"},[_c('span',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"toggle",on:{"click":_vm.toggle}},[_c('zg-icon',{attrs:{"icon":"edit","size":"small","color":"gray-500"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }